module.exports = __webpack_public_path__ + "static/media/logo.1bd10b76.svg";